<template>
  <router-view :key="$route.path" />
</template>

<script>
</script>

<style lang="scss">

</style>
